const ShopReceptionAdminIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2692_11631)"
        fill-opacity="0.1"
      />
      <path
        d="M24.0278 17.0625H21.6667V20.25L20.7222 19.5428L19.7778 20.25V17.0625H17.4167C17.1569 17.0625 16.9444 17.3016 16.9444 17.5938V23.9688C16.9444 24.2609 17.1569 24.5 17.4167 24.5H24.0278C24.2875 24.5 24.5 24.2609 24.5 23.9688V17.5938C24.5 17.3016 24.2875 17.0625 24.0278 17.0625ZM12.6944 14.9375H19.3056C19.5653 14.9375 19.7778 14.6984 19.7778 14.4062V8.03125C19.7778 7.73906 19.5653 7.5 19.3056 7.5H16.9444V10.6875L16 9.98027L15.0556 10.6875V7.5H12.6944C12.4347 7.5 12.2222 7.73906 12.2222 8.03125V14.4062C12.2222 14.6984 12.4347 14.9375 12.6944 14.9375ZM14.5833 17.0625H12.2222V20.25L11.2778 19.5428L10.3333 20.25V17.0625H7.97222C7.7125 17.0625 7.5 17.3016 7.5 17.5938V23.9688C7.5 24.2609 7.7125 24.5 7.97222 24.5H14.5833C14.8431 24.5 15.0556 24.2609 15.0556 23.9688V17.5938C15.0556 17.3016 14.8431 17.0625 14.5833 17.0625Z"
        fill="#052351"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2692_11631"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ShopReceptionAdminIconMenu
